import { z } from "zod";

export const loginSchema = z.object({
  email: z.string().email({ message: "Invalid email address" }),
  password: z
    .string()
    .min(12, { message: "Password must be at least 12 characters long" }),
});

export const changePasswordSchema = z
  .object({
    currentPassword: z
      .string()
      .min(1, { message: "Current password is required" }),
    newPassword: z
      .string()
      .min(12, { message: "New password must be at least 12 characters long" }),
    newPasswordConfirmation: z.string(),
  })
  .refine((data) => data.newPassword === data.newPasswordConfirmation, {
    message: "New passwords do not match",
    path: ["confirmPassword"], // path of error
  });

export const requestPasswordResetSchema = z.object({
  email: z.string().email({ message: "Please enter a valid email address" }),
});

export const resetPasswordSchema = z
  .object({
    token: z.string().min(1, { message: "Token is required" }),
    email: z.string().email(),
    password: z
      .string()
      .min(12, { message: "Password must be at least 12 characters long" }),
    passwordConfirmation: z.string(),
  })
  .refine((data) => data.password === data.passwordConfirmation, {
    message: "Passwords do not match",
    path: ["passwordConfirmation"],
  });

export const twoFactorSchema = z.object({
  otp: z
    .string()
    .length(6, { message: "Your one-time password must be 6 characters." }),
});

export const acceptInvitationSchema = z
  .object({
    password: z
      .string()
      .min(12, { message: "Password must be at least 12 characters long" }),
    passwordConfirmation: z.string(),
  })
  .refine((data) => data.password === data.passwordConfirmation, {
    message: "Passwords do not match",
    path: ["passwordConfirmation"],
  });

export type LoginFormData = z.infer<typeof loginSchema>;
export type ChangePasswordFormData = z.infer<typeof changePasswordSchema>;
export type RequestPasswordResetFormData = z.infer<
  typeof requestPasswordResetSchema
>;
export type ResetPasswordFormData = z.infer<typeof resetPasswordSchema>;
export type TwoFactorFormData = z.infer<typeof twoFactorSchema>;
export type AcceptInvitationFormData = z.infer<typeof acceptInvitationSchema>;
